// import $ from 'jquery';
import slickInit from './modules/slick';
import gsap from 'gsap';
import { new_map } from './modules/GoogleMap';
  
function scrollToElement(scroll_to_target, scroll_speed) {
    var scroll_to = $(scroll_to_target).offset().top - $('.site-header').outerHeight();
    $('html, body').animate({ scrollTop:  scroll_to}, scroll_speed, 'linear');
}

$(document).ready(function(){
    slickInit();
    
    $("body").on('DOMSubtreeModified', ".is-landing-page .nf-response-msg", function() {
        $(this).find('input, select').each(function() {
            if ($(this).val().length == 0) {
            // if ($(this).val().length == 0 || $(this).is(":hidden")) {
                $(this).attr('disabled', true);                    
            }
        });
        if($(this).find('.download-whitepaper').length > 0) {
            $(this).find('.download-whitepaper').each(function() {
                $(this)[0].click();
            });
        }
    });

    // Header Menu Popup
    $('body').on('click', '.menu-button', function (e) {
        e.preventDefault();
        $('body').toggleClass('menu-open body-hide-overflow').removeClass('submenu-open');
        $('.main-menu .menu-item-has-children').removeClass('submenu-active');
    });
    
    // Mobile Menu - Submenu Level 2
    $('body').on('click', '.main-menu > .menu-item-has-children > a > .icon', function (e) {
        // if ($(window).width() < 1023) {        
            e.preventDefault();
            // if($('.submenu-active').length > 0){
            if($(this).parent().parent().hasClass('submenu-active')){
                $(this).parent().parent().removeClass('submenu-active');
                $('body').removeClass('submenu-open');
            } else {
                $('.submenu-active').removeClass('submenu-active');
                $(this).parent().parent().toggleClass('submenu-active');
                $('body').toggleClass('submenu-open');
            }
        // }
    });
    $('body').on('click', '.submenu-back', function (e) {        
        e.preventDefault();
        $('body').removeClass('submenu-open');
        $('.submenu-active').find().removeClass('submenu-active');
    });

    // Mobile Menu - Submenu Level 3
    $('body').on('click', '.menu-level-2 > .menu-item-has-children > a', function (e) {  
        if ($(window).width() < 1023) {      
            e.preventDefault();
            $(this).next().slideToggle();
            $(this).parent().toggleClass('submenu-active');
        }
    });
    
    // Header - Search
    $('body').on('click', '.search-button', function (e) { 
        $('body').toggleClass('search-open'); 
    });

    // Homepage - Accordian
    $('body').on('click', '.accordian-item .title', function () { 
        if(!$(this).parent().hasClass('active')){
            $('.accordian-item').removeClass('active');
            $('.accordian-item .details').slideUp('slow');
            $(this).next().slideDown('slow');
            $(this).parent().addClass('active');
            return false;
        } else {
            $('.accordian-item').removeClass('active');
            $('.accordian-item .details').slideUp('slow');
        }
    });
    $('.accordian-item:first-child .title').trigger('click');

    $('.filter-form-main .filter-item select').on('change', function() {
        $(this).closest('form').submit();
    });

    // Product Archive page, Career Archive page - Filter form
    $('.filter-form-main').submit(function() {
        // Check if any field has value
        var form_has_value = false;
        $(this).find('input, select').each(function() {
            if (!($(this).val().length == 0)) {
                form_has_value = true;
                return false;
            }
        });

        if(form_has_value){
            // Remove empty field from parameter
            $(this).find('input, select').each(function() {
                if ($(this).val().length == 0) {
                // if ($(this).val().length == 0 || $(this).is(":hidden")) {
                    $(this).attr('disabled', true);                    
                }
            });
        } else {
            // Stop form submit if no value
            return false;            
        }
    });
    
    // Career Archive page - If has any parameter scroll to listing
    if($('body').hasClass('post-type-archive-career') || $('body').hasClass('tax-job-category') || $('body').hasClass('tax-job-type')){
        if ((window.location.href.indexOf('?') > -1) || (window.location.href.indexOf('page') > -1)) {
            scrollToElement('.block-career-list', 2000);
        }
    }

    // Career Archive page - on click "VIEW OPEN JOB LISTINGS" button scroll to listing
    $('body').on('click', 'a.wp-block-button__link', function (e) {
        var href = $(this).prop('href');
        if (href.indexOf('#') > -1) {
            e.preventDefault();
            var scroll_to_target = '.'+href.split('#')[1];
            scrollToElement(scroll_to_target, 2000);
        }
    });

    // Search page - Submit form on select changes of Category, Type, Sort
    $(document).ready(function() {
        $('.category-type-sort-from select').on('change', function() {
           $('.category-type-sort-from').submit();
        });
    });

    // Search page - If has any parameter scroll to listing
    if($('body').hasClass('search-results')){
        if ((window.location.href.indexOf('?') > -1) || (window.location.href.indexOf('page') > -1)) {
            scrollToElement('.block-post-type-list', 1000);
        }
    }

    // Product page - If has any parameter scroll to listing
    $( ".extra-information table" ).each(function() {
        $(this).wrap('<div class="table-wrap"></div>');
    });
    
    // Contact page - Google map
    let map = null;
    $('.acf-map').each(function () {
        // create map
        map = new_map($(this));
    });

    // Dots
    $( 'body' ).each(function( index ) {
        $('.site-main').prepend(`<div class="dots-main"><div class="dots-wrap">
        <div class="dot yellow"></div><div class="dot red"></div><div class="dot blue"></div><div class="dot green"></div>
        <div class="dot yellow yellow2"></div><div class="dot red red2"></div><div class="dot blue blue2"></div><div class="dot green green2"></div>
        <div class="dot yellow yellow3"></div><div class="dot red red3"></div><div class="dot blue blue3"></div><div class="dot green green3"></div>
        </div></div>`);
    });

    gsap.timeline()
    .from('.dot', {
        duration: 2,
        transformOrigin: '50% 50%',
        scale: 0,
        ease: 'elastic',
        stagger: 0.2
    }, 0)

    function centerMain() {
        gsap.set('.dots-wrap', {
            x: '50%',
            xPercent: -50,
            y: '50%',
            yPercent: -50
        });
    }
    window.onresize = centerMain;

    window.onmousemove = (e) => {
        let winPercent = {
                x: e.clientX / window.innerWidth,
                y: e.clientY / window.innerHeight
            },
            distFromCenter = 1 - Math.abs((e.clientX - window.innerWidth / 2) / window.innerWidth * 2);

        gsap.timeline({
                defaults: {
                    duration: 0.5,
                    overwrite: 'auto'
                }
            })
            .to('.dot', {
                x: 100 - 200 * winPercent.x,
                y: 100 - 200 * winPercent.y
            }, 0)
    }
});